import {AxiosResponse} from "axios";
import AxiosApiInstance, {APIBase} from "../AxiosApiInstance";
import {ApiRecommendationModel} from "./ApiRecommendationModel";

export const ApiRecommendationsPost: (payload: Omit<ApiRecommendationModel, "id">) => Promise<AxiosResponse<ApiRecommendationModel>> = (payload) => {
  return AxiosApiInstance.post(APIBase + "recommendations/", payload);
};